import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const CarrierConfigurationSelectOptionsQuery = graphql(/* GraphQL */ `
  query carrierConfigurationSelectOptions(
    $searchString: String
    $page: Int
    $pageSize: Int
  ) {
    carrierConfigurationSelectOptions(
      searchString: $searchString
      page: $page
      pageSize: $pageSize
    ) {
      id
      label
      value
    }
  }
`);
